import React from 'react';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import { Breadcrumb } from 'antd';

const { Item } = Breadcrumb;

const CustomBreadcrumb = ({ breadcrumb = [] }) => (
  <Breadcrumb>
    {breadcrumb.map(({ url, name }) => (
      <Item className="crumb" key={url + name}>
        <Link to={url} name={name}>
          {name}
        </Link>
      </Item>
    ))}
  </Breadcrumb>
);
CustomBreadcrumb.propTypes = {
  breadcrumb: propTypes.array,
};
export default CustomBreadcrumb;
